/*
 * @Author: Tahiti
 * @Date: 2025-10-28 18:00:00
 * @LastEditors: Tahiti
 * @LastEditTime: 2025-10-28 18:00:00
 * @Description: About Us 页面多语言配置
 * @FilePath: /weryai-web/locales/modules/aboutUs.ts
 */
export default {
    zh: {
        // 页面标题
        pageTitle: '关于 WeryAI',
        
        // Hero 部分
        subtitle: 'AI 视频、图像与角色生成的先行者',
        description: 'WeryAI 是新一代多模态内容创作平台。无论是令人惊艳的图像与视频、充满个性的动态角色，还是实现天马行空创意的无限画布，WeryAI 都能为您开启由 AI 驱动的无限创作可能。',
        
        // 平台部分
        platformTitle: '一个平台，无限可能',
        platformDescription: '告别频繁切换不同工具。WeryAI 为您提供无缝衔接的 AI 图像、视频生成器，先进的模型与工具，让您轻松创造震撼视觉效果，释放极致创意。',
        
        // 为什么选择我们
        whyChooseTitle: '为什么选择 WeryAI？',
        
        // 功能卡片
        professionalTeamTitle: '专业团队',
        professionalTeamDesc: '由一支具备 AI 技术与多媒体制作经验的多元化团队创立，WeryAI 致力于为您的创意之旅提供行业领先的专业体验。',
        
        innovativeTechTitle: '创新技术',
        innovativeTechDesc: '融合最新的 AI 技术突破，支持包括 Veo 3.1、Sora 2、Nano Banana、FLUX 等在内的多模型无缝接入，让您轻松生成高质量的视频、图像等内容。',
        
        userCentricTitle: '以用户为核心',
        userCentricDesc: '平台以用户体验为中心，提供直观易用的界面与无限画布，助您尽情探索无限创作空间。同时，我们的专属支持团队始终随时为您提供帮助。',
        
        // CTA 部分
        ctaTitle: '加入 1000 多万用户，使用 WeryAI 创造和启发灵感',
        ctaButton: '立即开启体验',
        subjectName: '公司名称',
        registeredAddress: '注册地址',
        mail: '邮箱',
        corporate: '公司信息'
    },
    en: {
        // Page title
        pageTitle: 'About WeryAI',
        
        // Hero section
        subtitle: 'Pioneer in AI Video, Image & Digital Human Generation',
        description: 'WeryAI is a next-generation multimodal content creation platform. Whether it\'s stunning images and videos, dynamic digital humans with personality, or infinite canvases to realize wild ideas, WeryAI unlocks unlimited creative possibilities powered by AI.',
        
        // Platform section
        platformTitle: 'One Platform, Infinite Possibilities',
        platformDescription: 'Say goodbye to frequent tool switching. WeryAI provides seamlessly integrated AI image and video generators, advanced models and tools, allowing you to easily create stunning visual effects and unleash ultimate creativity.',
        
        // Why choose us
        whyChooseTitle: 'Why Choose WeryAI?',
        
        // Feature cards
        professionalTeamTitle: 'Professional Team',
        professionalTeamDesc: 'Founded by a diverse team with AI technology and multimedia production experience, WeryAI is committed to providing industry-leading professional experiences for your creative journey.',
        
        innovativeTechTitle: 'Innovative Technology',
        innovativeTechDesc: 'Integrating the latest AI technology breakthroughs, supporting seamless access to multiple models including Veo 3.1, Sora 2, Nano Banana, FLUX, and more, allowing you to easily generate high-quality videos, images, and other content.',
        
        userCentricTitle: 'User-Centric',
        userCentricDesc: 'The platform centers on user experience, providing an intuitive and easy-to-use interface with infinite canvas, helping you explore unlimited creative space. Meanwhile, our dedicated support team is always ready to assist you.',
        
        // CTA section
        ctaTitle: 'Join 10+ Million Users Creating and Inspiring with WeryAI',
        ctaButton: 'Start Creating Now',
        subjectName: 'Company Name',
        registeredAddress: 'Registered Address',
        mail: 'Email',
        corporate: 'Corporate Information',
    },
    ja: {
        // ページタイトル
        pageTitle: 'WeryAI について',
        
        // Hero セクション
        subtitle: 'AI ビデオ、画像、デジタルヒューマン生成のパイオニア',
        description: 'WeryAI は次世代のマルチモーダルコンテンツ制作プラットフォームです。素晴らしい画像やビデオ、個性豊かな動的デジタルヒューマン、無限のキャンバスで奇想天外なアイデアを実現するなど、WeryAI は AI によって無限の創造的可能性を解き放ちます。',
        
        // プラットフォームセクション
        platformTitle: '一つのプラットフォーム、無限の可能性',
        platformDescription: '頻繁なツールの切り替えにさようなら。WeryAI は、シームレスに統合された AI 画像・ビデオジェネレーター、高度なモデルとツールを提供し、驚くべき視覚効果を簡単に作成し、究極の創造性を解き放つことができます。',
        
        // なぜ私たちを選ぶ
        whyChooseTitle: 'なぜ WeryAI を選ぶのか？',
        
        // 機能カード
        professionalTeamTitle: 'プロフェッショナルチーム',
        professionalTeamDesc: 'AI 技術とマルチメディア制作の経験を持つ多様なチームによって設立された WeryAI は、あなたのクリエイティブな旅に業界をリードするプロフェッショナルな体験を提供することに専念しています。',
        
        innovativeTechTitle: '革新的技術',
        innovativeTechDesc: '最新の AI 技術の突破を統合し、Veo 3.1、Sora 2、Nano Banana、FLUX などを含む複数のモデルへのシームレスなアクセスをサポートし、高品質のビデオ、画像などのコンテンツを簡単に生成できます。',
        
        userCentricTitle: 'ユーザー中心',
        userCentricDesc: 'プラットフォームはユーザーエクスペリエンスを中心に、直感的で使いやすいインターフェースと無限のキャンバスを提供し、無限の創造的空間を探索するのをサポートします。また、専任のサポートチームがいつでもお手伝いします。',
        
        // CTA セクション
        ctaTitle: '1000 万人以上のユーザーが WeryAI で創造とインスピレーションを得ています',
        ctaButton: '今すぐ始める',
        subjectName: '会社名',
        registeredAddress: '登録住所',
        mail: 'メール',
        corporate: '会社情報',
    },
    ko: {
        // 페이지 제목
        pageTitle: 'WeryAI 소개',
        
        // Hero 섹션
        subtitle: 'AI 비디오, 이미지 및 디지털 휴먼 생성의 선구자',
        description: 'WeryAI는 차세대 멀티모달 콘텐츠 제작 플랫폼입니다. 놀라운 이미지와 비디오, 개성 있는 동적 디지털 휴먼, 무한한 캔버스로 기발한 아이디어를 실현하든, WeryAI는 AI로 구동되는 무한한 창의적 가능성을 열어줍니다。',
        
        // 플랫폼 섹션
        platformTitle: '하나의 플랫폼, 무한한 가능성',
        platformDescription: '잦은 도구 전환에 작별하세요. WeryAI는 원활하게 통합된 AI 이미지 및 비디오 생성기, 고급 모델 및 도구를 제공하여 놀라운 시각 효과를 쉽게 만들고 궁극의 창의성을 발휘할 수 있습니다。',
        
        // 우리를 선택하는 이유
        whyChooseTitle: 'WeryAI를 선택하는 이유는?',
        
        // 기능 카드
        professionalTeamTitle: '전문 팀',
        professionalTeamDesc: 'AI 기술 및 멀티미디어 제작 경험을 가진 다양한 팀이 설립한 WeryAI는 여러분의 창의적인 여정에 업계를 선도하는 전문적인 경험을 제공하는 데 전념하고 있습니다。',
        
        innovativeTechTitle: '혁신적인 기술',
        innovativeTechDesc: '최신 AI 기술 혁신을 통합하여 Veo 3.1, Sora 2, Nano Banana, FLUX 등을 포함한 여러 모델에 원활하게 액세스하여 고품질 비디오, 이미지 및 기타 콘텐츠를 쉽게 생성할 수 있습니다。',
        
        userCentricTitle: '사용자 중심',
        userCentricDesc: '플랫폼은 사용자 경험을 중심으로 직관적이고 사용하기 쉬운 인터페이스와 무한한 캔버스를 제공하여 무한한 창의적 공간을 탐색하는 데 도움을 줍니다. 또한 전담 지원 팀이 항상 도와드릴 준비가 되어 있습니다。',
        
        // CTA 섹션
        ctaTitle: 'WeryAI로 창조하고 영감을 얻는 1000만 명 이상의 사용자에 합류하세요',
        ctaButton: '지금 시작하기',
        subjectName: '회사명',
        registeredAddress: '등록 주소',
        mail: '이메일',
        corporate: '회사 정보',
    },
    tw: {
        // 頁面標題
        pageTitle: '關於 WeryAI',

        // Hero 區塊
        subtitle: 'AI 影片、圖像與角色生成的先行者',
        description:
            'WeryAI 是新一代多模態內容創作平台。無論是令人驚豔的圖像與影片、充滿個性的動態角色，或是實現天馬行空創意的無限畫布，WeryAI 都能為您開啟由 AI 驅動的無限創作可能。',

        // 平台區塊
        platformTitle: '一個平台，無限可能',
        platformDescription:
            '告別頻繁切換不同工具。WeryAI 提供無縫銜接的 AI 圖像、影片生成器與先進模型工具，讓您輕鬆創造震撼視覺效果，釋放極致創意。',

        // 為什麼選擇我們
        whyChooseTitle: '為什麼選擇 WeryAI？',

        // 功能卡片
        professionalTeamTitle: '專業團隊',
        professionalTeamDesc:
            '由具備 AI 技術與多媒體製作經驗的多元團隊創立，WeryAI 致力於為您的創作之旅提供業界領先的專業體驗。',

        innovativeTechTitle: '創新技術',
        innovativeTechDesc:
            '融合最新 AI 技術突破，支援 Veo 3.1、Sora 2、Nano Banana、FLUX 等多模型無縫接入，讓您輕鬆生成高品質影片與圖像等內容。',

        userCentricTitle: '以使用者為核心',
        userCentricDesc:
            '平台以使用者體驗為核心，提供直觀易用的介面與無限畫布，協助您探索無限創作空間。我們的專屬支援團隊也隨時準備協助您。',

        // CTA 區塊
        ctaTitle: '加入 1000 萬以上用戶，與 WeryAI 一起創作與啟發靈感',
        ctaButton: '立即開始創作',
        subjectName: '公司名稱',
        registeredAddress: '註冊地址',
        mail: '電子郵件',
        corporate: '公司資訊',
    },
    pl: {
        // Page title
        pageTitle: 'O WeryAI',

        // Hero section
        subtitle: 'Pionier w generowaniu wideo, obrazów i postaci AI',
        description:
            'WeryAI to nowej generacji platforma tworzenia treści multimodalnych. Od zachwycających obrazów i wideo, przez dynamiczne postacie AI, po nieskończone płótno do realizacji śmiałych pomysłów — WeryAI otwiera nieograniczone możliwości kreatywne.',

        // Platform section
        platformTitle: 'Jedna platforma, nieskończone możliwości',
        platformDescription:
            'Pożegnaj ciągłe przełączanie narzędzi. WeryAI łączy generatory obrazów i wideo AI, zaawansowane modele oraz narzędzia, abyś mógł łatwo tworzyć imponujące efekty wizualne.',

        // Why choose us
        whyChooseTitle: 'Dlaczego WeryAI?',

        // Feature cards
        professionalTeamTitle: 'Profesjonalny zespół',
        professionalTeamDesc:
            'Stworzony przez różnorodny zespół z doświadczeniem w AI i produkcji multimediów, WeryAI zapewnia profesjonalne doświadczenie na najwyższym poziomie.',

        innovativeTechTitle: 'Innowacyjna technologia',
        innovativeTechDesc:
            'Integrujemy najnowsze przełomy AI i zapewniamy płynny dostęp do wielu modeli, m.in. Veo 3.1, Sora 2, Nano Banana, FLUX i innych — aby generować wideo, obrazy i inne treści wysokiej jakości.',

        userCentricTitle: 'Zorientowane na użytkownika',
        userCentricDesc:
            'Platforma stawia na doświadczenie użytkownika: intuicyjny interfejs i nieskończone płótno pomagają odkrywać kreatywność. Nasz zespół wsparcia jest zawsze gotowy do pomocy.',

        // CTA section
        ctaTitle: 'Dołącz do ponad 10 milionów użytkowników tworzących z WeryAI',
        ctaButton: 'Zacznij tworzyć',
        subjectName: 'Nazwa firmy',
        registeredAddress: 'Adres rejestrowy',
        mail: 'E-mail',
        corporate: 'Informacje korporacyjne',
    },
    es: {
        // Título de página
        pageTitle: 'Acerca de WeryAI',
        
        // Sección Hero
        subtitle: 'Pionero en Generación de Video, Imagen y Humanos Digitales con IA',
        description: 'WeryAI es una plataforma de creación de contenido multimodal de próxima generación. Ya sean imágenes y videos impresionantes, humanos digitales dinámicos con personalidad o lienzos infinitos para realizar ideas descabelladas, WeryAI desbloquea posibilidades creativas ilimitadas impulsadas por IA.',
        
        // Sección de plataforma
        platformTitle: 'Una Plataforma, Posibilidades Infinitas',
        platformDescription: 'Diga adiós al cambio frecuente de herramientas. WeryAI proporciona generadores de imágenes y videos de IA perfectamente integrados, modelos y herramientas avanzadas, lo que le permite crear fácilmente efectos visuales impresionantes y liberar la máxima creatividad.',
        
        // Por qué elegirnos
        whyChooseTitle: '¿Por qué elegir WeryAI?',
        
        // Tarjetas de características
        professionalTeamTitle: 'Equipo Profesional',
        professionalTeamDesc: 'Fundada por un equipo diverso con experiencia en tecnología de IA y producción multimedia, WeryAI está comprometida a proporcionar experiencias profesionales líderes en la industria para su viaje creativo.',
        
        innovativeTechTitle: 'Tecnología Innovadora',
        innovativeTechDesc: 'Integrando los últimos avances en tecnología de IA, admitiendo acceso perfecto a múltiples modelos, incluidos Veo 3.1, Sora 2, Nano Banana, FLUX y más, lo que le permite generar fácilmente videos, imágenes y otro contenido de alta calidad.',
        
        userCentricTitle: 'Centrado en el Usuario',
        userCentricDesc: 'La plataforma se centra en la experiencia del usuario, proporcionando una interfaz intuitiva y fácil de usar con lienzo infinito, ayudándole a explorar un espacio creativo ilimitado. Mientras tanto, nuestro equipo de soporte dedicado siempre está listo para ayudarle.',
        
        // Sección CTA
        ctaTitle: 'Únase a más de 10 millones de usuarios que crean e inspiran con WeryAI',
        ctaButton: 'Comienza a Crear Ahora',
        subjectName: 'Nombre de la empresa',
        registeredAddress: 'Dirección registrada',
        mail: 'Correo electrónico',
        corporate: 'Información Corporativa',
    },
    fr: {
        // Titre de page
        pageTitle: 'À propos de WeryAI',
        
        // Section Hero
        subtitle: 'Pionnier de la Génération de Vidéos, Images et Humains Numériques par IA',
        description: 'WeryAI est une plateforme de création de contenu multimodal de nouvelle génération. Qu\'il s\'agisse d\'images et de vidéos époustouflantes, d\'humains numériques dynamiques avec personnalité ou de toiles infinies pour réaliser des idées folles, WeryAI déverrouille des possibilités créatives illimitées alimentées par l\'IA.',
        
        // Section plateforme
        platformTitle: 'Une Plateforme, Possibilités Infinies',
        platformDescription: 'Dites adieu aux changements d\'outils fréquents. WeryAI fournit des générateurs d\'images et de vidéos IA parfaitement intégrés, des modèles et des outils avancés, vous permettant de créer facilement des effets visuels époustouflants et de libérer une créativité ultime.',
        
        // Pourquoi nous choisir
        whyChooseTitle: 'Pourquoi Choisir WeryAI?',
        
        // Cartes de fonctionnalités
        professionalTeamTitle: 'Équipe Professionnelle',
        professionalTeamDesc: 'Fondée par une équipe diversifiée avec une expérience en technologie IA et production multimédia, WeryAI s\'engage à fournir des expériences professionnelles de pointe pour votre parcours créatif.',
        
        innovativeTechTitle: 'Technologie Innovante',
        innovativeTechDesc: 'Intégrant les dernières percées en technologie IA, prenant en charge l\'accès transparent à plusieurs modèles, y compris Veo 3.1, Sora 2, Nano Banana, FLUX et plus, vous permettant de générer facilement des vidéos, des images et d\'autres contenus de haute qualité.',
        
        userCentricTitle: 'Centré sur l\'Utilisateur',
        userCentricDesc: 'La plateforme se concentre sur l\'expérience utilisateur, fournissant une interface intuitive et facile à utiliser avec une toile infinie, vous aidant à explorer un espace créatif illimité. Pendant ce temps, notre équipe de support dédiée est toujours prête à vous aider.',
        
        // Section CTA
        ctaTitle: 'Rejoignez plus de 10 millions d\'utilisateurs créant et inspirant avec WeryAI',
        ctaButton: 'Commencer à Créer Maintenant',
        subjectName: 'Nom de l\'entreprise',
        registeredAddress: 'Adresse enregistrée',
        mail: 'E-mail',
        corporate: 'Informations sur l\'entreprise',
    },
    de: {
        // Seitentitel
        pageTitle: 'Über WeryAI',
        
        // Hero-Bereich
        subtitle: 'Pionier in der KI-Video-, Bild- und Digitalen Menschen-Generierung',
        description: 'WeryAI ist eine multimodale Content-Erstellungsplattform der nächsten Generation. Ob atemberaubende Bilder und Videos, dynamische digitale Menschen mit Persönlichkeit oder unendliche Leinwände zur Verwirklichung wilder Ideen - WeryAI erschließt unbegrenzte kreative Möglichkeiten, die von KI angetrieben werden.',
        
        // Plattform-Bereich
        platformTitle: 'Eine Plattform, Unendliche Möglichkeiten',
        platformDescription: 'Verabschieden Sie sich von häufigem Tool-Wechsel. WeryAI bietet nahtlos integrierte KI-Bild- und Video-Generatoren, fortschrittliche Modelle und Tools, mit denen Sie mühelos atemberaubende visuelle Effekte erstellen und ultimative Kreativität entfesseln können.',
        
        // Warum uns wählen
        whyChooseTitle: 'Warum WeryAI Wählen?',
        
        // Funktionskarten
        professionalTeamTitle: 'Professionelles Team',
        professionalTeamDesc: 'Gegründet von einem vielfältigen Team mit Erfahrung in KI-Technologie und Multimedia-Produktion, engagiert sich WeryAI dafür, branchenführende professionelle Erfahrungen für Ihre kreative Reise zu bieten.',
        
        innovativeTechTitle: 'Innovative Technologie',
        innovativeTechDesc: 'Integration der neuesten KI-Technologie-Durchbrüche, Unterstützung des nahtlosen Zugriffs auf mehrere Modelle, einschließlich Veo 3.1, Sora 2, Nano Banana, FLUX und mehr, sodass Sie mühelos hochwertige Videos, Bilder und andere Inhalte generieren können.',
        
        userCentricTitle: 'Benutzerzentriert',
        userCentricDesc: 'Die Plattform konzentriert sich auf die Benutzererfahrung und bietet eine intuitive und benutzerfreundliche Oberfläche mit unendlicher Leinwand, die Ihnen hilft, unbegrenzten kreativen Raum zu erkunden. Währenddessen ist unser engagiertes Support-Team immer bereit, Ihnen zu helfen.',
        
        // CTA-Bereich
        ctaTitle: 'Schließen Sie sich über 10 Millionen Benutzern an, die mit WeryAI kreieren und inspirieren',
        ctaButton: 'Jetzt Erstellen',
        subjectName: 'Firmenname',
        registeredAddress: 'Registrierte Adresse',
        mail: 'E-Mail',
        corporate: 'Unternehmensinformationen',
    },
    ru: {
        // Заголовок страницы
        pageTitle: 'О WeryAI',
        
        // Hero секция
        subtitle: 'Пионер в Генерации ИИ Видео, Изображений и Цифровых Людей',
        description: 'WeryAI — это платформа создания мультимодального контента нового поколения. Будь то потрясающие изображения и видео, динамичные цифровые люди с характером или бесконечные холсты для реализации диких идей, WeryAI открывает неограниченные творческие возможности, управляемые ИИ.',
        
        // Раздел платформы
        platformTitle: 'Одна Платформа, Бесконечные Возможности',
        platformDescription: 'Попрощайтесь с частой сменой инструментов. WeryAI предоставляет бесшовно интегрированные генераторы изображений и видео с ИИ, передовые модели и инструменты, позволяющие легко создавать потрясающие визуальные эффекты и раскрывать максимальную креативность.',
        
        // Почему выбрать нас
        whyChooseTitle: 'Почему Выбрать WeryAI?',
        
        // Карточки функций
        professionalTeamTitle: 'Профессиональная Команда',
        professionalTeamDesc: 'Основанная разнообразной командой с опытом в технологии ИИ и мультимедийном производстве, WeryAI стремится предоставлять ведущий в отрасли профессиональный опыт для вашего творческого путешествия.',
        
        innovativeTechTitle: 'Инновационная Технология',
        innovativeTechDesc: 'Интегрируя последние прорывы в технологии ИИ, поддерживая бесшовный доступ к нескольким моделям, включая Veo 3.1, Sora 2, Nano Banana, FLUX и другие, позволяя легко генерировать высококачественные видео, изображения и другой контент.',
        
        userCentricTitle: 'Ориентированность на Пользователя',
        userCentricDesc: 'Платформа сосредоточена на пользовательском опыте, предоставляя интуитивно понятный и простой в использовании интерфейс с бесконечным холстом, помогая вам исследовать неограниченное творческое пространство. В то же время наша специальная команда поддержки всегда готова помочь вам.',
        
        // Раздел CTA
        ctaTitle: 'Присоединяйтесь к более чем 10 миллионам пользователей, создающих и вдохновляющихся с WeryAI',
        ctaButton: 'Начать Создавать Сейчас',
        subjectName: 'Название компании',
        registeredAddress: 'Юридический адрес',
        mail: 'Электронная почта',
        corporate: 'Сведения о компании',
    },
    pt: {
        // Título da página
        pageTitle: 'Sobre WeryAI',
        
        // Seção Hero
        subtitle: 'Pioneiro na Geração de Vídeo, Imagem e Humanos Digitais com IA',
        description: 'WeryAI é uma plataforma de criação de conteúdo multimodal de próxima geração. Sejam imagens e vídeos impressionantes, humanos digitais dinâmicos com personalidade ou telas infinitas para realizar ideias malucas, WeryAI desbloqueia possibilidades criativas ilimitadas impulsionadas por IA.',
        
        // Seção da plataforma
        platformTitle: 'Uma Plataforma, Possibilidades Infinitas',
        platformDescription: 'Diga adeus à troca frequente de ferramentas. WeryAI fornece geradores de imagens e vídeos de IA perfeitamente integrados, modelos e ferramentas avançadas, permitindo criar facilmente efeitos visuais impressionantes e liberar criatividade máxima.',
        
        // Por que nos escolher
        whyChooseTitle: 'Por que Escolher WeryAI?',
        
        // Cartões de recursos
        professionalTeamTitle: 'Equipe Profissional',
        professionalTeamDesc: 'Fundada por uma equipe diversificada com experiência em tecnologia de IA e produção multimídia, WeryAI está comprometida em fornecer experiências profissionais líderes do setor para sua jornada criativa.',
        
        innovativeTechTitle: 'Tecnologia Inovadora',
        innovativeTechDesc: 'Integrando os últimos avanços em tecnologia de IA, suportando acesso perfeito a vários modelos, incluindo Veo 3.1, Sora 2, Nano Banana, FLUX e mais, permitindo gerar facilmente vídeos, imagens e outros conteúdos de alta qualidade.',
        
        userCentricTitle: 'Centrado no Usuário',
        userCentricDesc: 'A plataforma se concentra na experiência do usuário, fornecendo uma interface intuitiva e fácil de usar com tela infinita, ajudando você a explorar espaço criativo ilimitado. Enquanto isso, nossa equipe de suporte dedicada está sempre pronta para ajudá-lo.',
        
        // Seção CTA
        ctaTitle: 'Junte-se a mais de 10 milhões de usuários criando e inspirando com WeryAI',
        ctaButton: 'Comece a Criar Agora',
        subjectName: 'Nome da empresa',
        registeredAddress: 'Endereço registrado',
        mail: 'E-mail',
        corporate: 'Informações corporativas',
    },
    it: {
        // Titolo della pagina
        pageTitle: 'Chi Siamo - WeryAI',
        
        // Sezione Hero
        subtitle: 'Pioniere nella Generazione di Video, Immagini e Umani Digitali con IA',
        description: 'WeryAI è una piattaforma di creazione di contenuti multimodali di nuova generazione. Che si tratti di immagini e video mozzafiato, umani digitali dinamici con personalità o tele infinite per realizzare idee folli, WeryAI sblocca possibilità creative illimitate alimentate dall\'IA.',
        
        // Sezione piattaforma
        platformTitle: 'Una Piattaforma, Possibilità Infinite',
        platformDescription: 'Dite addio al cambio frequente di strumenti. WeryAI fornisce generatori di immagini e video IA perfettamente integrati, modelli e strumenti avanzati, permettendovi di creare facilmente effetti visivi mozzafiato e liberare creatività massima.',
        
        // Perché sceglierci
        whyChooseTitle: 'Perché Scegliere WeryAI?',
        
        // Schede funzionalità
        professionalTeamTitle: 'Team Professionale',
        professionalTeamDesc: 'Fondata da un team diversificato con esperienza in tecnologia IA e produzione multimediale, WeryAI si impegna a fornire esperienze professionali leader del settore per il vostro viaggio creativo.',
        
        innovativeTechTitle: 'Tecnologia Innovativa',
        innovativeTechDesc: 'Integrando gli ultimi progressi della tecnologia IA, supportando l\'accesso senza soluzione di continuità a più modelli, inclusi Veo 3.1, Sora 2, Nano Banana, FLUX e altro, permettendovi di generare facilmente video, immagini e altri contenuti di alta qualità.',
        
        userCentricTitle: 'Centrato sull\'Utente',
        userCentricDesc: 'La piattaforma si concentra sull\'esperienza utente, fornendo un\'interfaccia intuitiva e facile da usare con tela infinita, aiutandovi a esplorare spazio creativo illimitato. Nel frattempo, il nostro team di supporto dedicato è sempre pronto ad assistervi.',
        
        // Sezione CTA
        ctaTitle: 'Unisciti a oltre 10 milioni di utenti che creano e si ispirano con WeryAI',
        ctaButton: 'Inizia a Creare Ora',
        subjectName: 'Nome dell\'azienda',
        registeredAddress: 'Indirizzo registrato',
        mail: 'Email',
        corporate: 'Informazioni aziendali',
    },
    ar: {
        // عنوان الصفحة
        pageTitle: 'حول WeryAI',
        
        // قسم البطل
        subtitle: 'رائد في توليد الذكاء الاصطناعي للفيديو والصور والبشر الرقميين',
        description: 'WeryAI هي منصة إنشاء محتوى متعدد الوسائط من الجيل القادم. سواء كانت صور وفيديوهات مذهلة أو بشر رقميون ديناميكيون مع شخصية أو لوحات لا نهائية لتحقيق أفكار جامحة، فإن WeryAI تفتح إمكانيات إبداعية غير محدودة مدعومة بالذكاء الاصطناعي.',
        
        // قسم المنصة
        platformTitle: 'منصة واحدة، إمكانيات لا نهائية',
        platformDescription: 'قل وداعاً للتبديل المتكرر للأدوات. توفر WeryAI مولدات صور وفيديو بالذكاء الاصطناعي متكاملة بسلاسة ونماذج وأدوات متقدمة، مما يتيح لك إنشاء تأثيرات بصرية مذهلة بسهولة وإطلاق العنان للإبداع النهائي.',
        
        // لماذا تختارنا
        whyChooseTitle: 'لماذا تختار WeryAI؟',
        
        // بطاقات الميزات
        professionalTeamTitle: 'فريق محترف',
        professionalTeamDesc: 'أسسها فريق متنوع لديه خبرة في تكنولوجيا الذكاء الاصطناعي والإنتاج متعدد الوسائط، وتلتزم WeryAI بتوفير تجارب احترافية رائدة في الصناعة لرحلتك الإبداعية.',
        
        innovativeTechTitle: 'تكنولوجيا مبتكرة',
        innovativeTechDesc: 'دمج أحدث اختراقات تكنولوجيا الذكاء الاصطناعي، ودعم الوصول السلس إلى نماذج متعددة بما في ذلك Veo 3.1 و Sora 2 و Nano Banana و FLUX وغيرها، مما يتيح لك توليد مقاطع فيديو وصور ومحتوى آخر عالي الجودة بسهولة.',
        
        userCentricTitle: 'محوره المستخدم',
        userCentricDesc: 'تركز المنصة على تجربة المستخدم، وتوفر واجهة بديهية وسهلة الاستخدام مع لوحة لا نهائية، مما يساعدك على استكشاف مساحة إبداعية غير محدودة. في الوقت نفسه، فريق الدعم المخصص لدينا جاهز دائماً لمساعدتك.',
        
        // قسم الدعوة للعمل
        ctaTitle: 'انضم إلى أكثر من 10 ملايين مستخدم يبدعون ويلهمون مع WeryAI',
        ctaButton: 'ابدأ الإنشاء الآن',
        subjectName: 'اسم الشركة',
        registeredAddress: 'العنوان المسجل',
        mail: 'البريد الإلكتروني',
        corporate: 'معلومات الشركة',
    },
    th: {
        // Page title
        pageTitle: 'เกี่ยวกับ WeryAI',
        
        // Hero section
        subtitle: 'ผู้บุกเบิกการสร้างวิดีโอ ภาพ และมนุษย์ดิจิทัลด้วย AI',
        description: 'WeryAI คือแพลตฟอร์มสร้างสรรค์คอนเทนต์แบบมัลติโหมดรุ่นใหม่ ไม่ว่าจะเป็นภาพและวิดีโอสุดตระการตา มนุษย์ดิจิทัลที่มีบุคลิก หรือผืนผ้าใบไร้ขอบเขตเพื่อทำไอเดียสุดล้ำ WeryAI ปลดล็อกความเป็นไปได้ด้านความคิดสร้างสรรค์อย่างไร้ขีดจำกัดด้วยพลัง AI',
        
        // Platform section
        platformTitle: 'แพลตฟอร์มเดียว ความเป็นไปได้ไม่สิ้นสุด',
        platformDescription: 'บอกลาการสลับเครื่องมือบ่อยๆ WeryAI รวมเครื่องมือสร้างภาพและวิดีโอด้วย AI ไว้อย่างไร้รอยต่อ พร้อมโมเดลและเครื่องมือขั้นสูง ช่วยให้คุณสร้างเอฟเฟกต์ภาพอันน่าทึ่งได้ง่าย และปลดปล่อยความคิดสร้างสรรค์ขั้นสุด',
        
        // Why choose us
        whyChooseTitle: 'ทำไมต้องเลือก WeryAI?',
        
        // Feature cards
        professionalTeamTitle: 'ทีมมืออาชีพ',
        professionalTeamDesc: 'ก่อตั้งโดยทีมงานหลากหลายที่มีประสบการณ์ด้านเทคโนโลยี AI และการผลิตมัลติมีเดีย WeryAI มุ่งมั่นมอบประสบการณ์ระดับมืออาชีพชั้นนำให้กับเส้นทางสร้างสรรค์ของคุณ',
        
        innovativeTechTitle: 'เทคโนโลยีนวัตกรรม',
        innovativeTechDesc: 'ผสานความก้าวหน้าล่าสุดของเทคโนโลยี AI และรองรับการเข้าถึงหลายโมเดลอย่างไร้รอยต่อ เช่น Veo 3.1, Sora 2, Nano Banana, FLUX และอื่นๆ ช่วยให้คุณสร้างวิดีโอ ภาพ และคอนเทนต์คุณภาพสูงได้อย่างง่ายดาย',
        
        userCentricTitle: 'ยึดผู้ใช้เป็นศูนย์กลาง',
        userCentricDesc: 'แพลตฟอร์มให้ความสำคัญกับประสบการณ์ผู้ใช้ มีอินเทอร์เฟซที่ใช้งานง่ายพร้อมผืนผ้าใบไร้ขีดจำกัด ช่วยให้คุณสำรวจพื้นที่สร้างสรรค์ได้ไม่รู้จบ พร้อมทีมซัพพอร์ตที่พร้อมช่วยเหลือเสมอ',
        
        // CTA section
        ctaTitle: 'ร่วมกับผู้ใช้กว่า 10 ล้านคนที่กำลังสร้างสรรค์และได้แรงบันดาลใจจาก WeryAI',
        ctaButton: 'เริ่มสร้างสรรค์ตอนนี้',
        subjectName: 'ชื่อบริษัท',
        registeredAddress: 'ที่อยู่จดทะเบียน',
        mail: 'อีเมล',
        corporate: 'ข้อมูลบริษัท',
    },
    da: {
        // Page title
        pageTitle: 'Om WeryAI',
        
        // Hero section
        subtitle: 'Pioner inden for AI‑video, billeder og digitale mennesker',
        description: 'WeryAI er en næste‑generations multimodal platform til indholdsskabelse. Uanset om det er imponerende billeder og videoer, dynamiske digitale mennesker med personlighed eller uendelige lærreder til vilde idéer, åbner WeryAI for ubegrænsede kreative muligheder drevet af AI.',
        
        // Platform section
        platformTitle: 'Én platform, uendelige muligheder',
        platformDescription: 'Sig farvel til konstant værktøjsskifte. WeryAI tilbyder sømløst integrerede AI‑billed- og videogeneratorer samt avancerede modeller og værktøjer, så du nemt kan skabe fantastiske visuelle effekter og frigøre maksimal kreativitet.',
        
        // Why choose us
        whyChooseTitle: 'Hvorfor vælge WeryAI?',
        
        // Feature cards
        professionalTeamTitle: 'Professionelt team',
        professionalTeamDesc: 'Grundlagt af et mangfoldigt team med erfaring inden for AI‑teknologi og multimediaproduktion. WeryAI er dedikeret til at levere branchens førende professionelle oplevelser til din kreative rejse.',
        
        innovativeTechTitle: 'Innovativ teknologi',
        innovativeTechDesc: 'Integrerer de nyeste AI‑gennembrud og understøtter problemfri adgang til flere modeller som Veo 3.1, Sora 2, Nano Banana, FLUX m.fl., så du let kan generere video, billeder og andet indhold i høj kvalitet.',
        
        userCentricTitle: 'Brugercentreret',
        userCentricDesc: 'Platformen sætter brugeroplevelsen i centrum med en intuitiv og let anvendelig grænseflade samt uendeligt lærred, der hjælper dig med at udforske ubegrænset kreativt rum. Samtidig står vores dedikerede supportteam klar til at hjælpe.',
        
        // CTA section
        ctaTitle: 'Slut dig til 10+ millioner brugere, der skaber og inspireres med WeryAI',
        ctaButton: 'Begynd at skabe nu',
        subjectName: 'Virksomhedsnavn',
        registeredAddress: 'Registreret adresse',
        mail: 'E-mail',
        corporate: 'Virksomhedsoplysninger',
    },
    no: {
        // Page title
        pageTitle: 'Om WeryAI',
        
        // Hero section
        subtitle: 'Pioner innen AI‑video, bilder og digitale mennesker',
        description: 'WeryAI er en neste generasjons multimodal plattform for innholdsskaping. Enten det er imponerende bilder og videoer, dynamiske digitale mennesker med personlighet eller uendelige lerreter for ville ideer, åpner WeryAI for ubegrensede kreative muligheter drevet av AI.',
        
        // Platform section
        platformTitle: 'Én plattform, uendelige muligheter',
        platformDescription: 'Si farvel til hyppig verktøybytte. WeryAI tilbyr sømløst integrerte AI‑bilde- og videogeneratorer, avanserte modeller og verktøy, slik at du enkelt kan skape fantastiske visuelle effekter og slippe løs maksimal kreativitet.',
        
        // Why choose us
        whyChooseTitle: 'Hvorfor velge WeryAI?',
        
        // Feature cards
        professionalTeamTitle: 'Profesjonelt team',
        professionalTeamDesc: 'Grunnlagt av et mangfoldig team med erfaring innen AI‑teknologi og multimediaproduksjon, er WeryAI dedikert til å gi bransjeledende profesjonelle opplevelser for din kreative reise.',
        
        innovativeTechTitle: 'Innovativ teknologi',
        innovativeTechDesc: 'Integrerer de nyeste AI‑gjennombruddene og støtter sømløs tilgang til flere modeller som Veo 3.1, Sora 2, Nano Banana, FLUX og mer, slik at du enkelt kan generere videoer, bilder og annet innhold av høy kvalitet.',
        
        userCentricTitle: 'Brukersentrert',
        userCentricDesc: 'Plattformen setter brukeropplevelsen i sentrum med et intuitivt og brukervennlig grensesnitt og uendelig lerret, som hjelper deg å utforske ubegrenset kreativt rom. Samtidig står vårt dedikerte supportteam klart til å hjelpe.',
        
        // CTA section
        ctaTitle: 'Bli med over 10 millioner brukere som skaper og blir inspirert med WeryAI',
        ctaButton: 'Begynn å skape nå',
        subjectName: 'Firmanavn',
        registeredAddress: 'Registrert adresse',
        mail: 'E-post',
        corporate: 'Bedriftsinformasjon',
    },
    nl: {
        // Page title
        pageTitle: 'Over WeryAI',
        
        // Hero section
        subtitle: 'Pionier in AI‑video, afbeeldingen en digitale mensen',
        description: 'WeryAI is een next‑gen multimodaal contentplatform. Of het nu gaat om verbluffende beelden en video’s, dynamische digitale mensen met persoonlijkheid of oneindige canvassen voor wilde ideeën, WeryAI ontsluit onbeperkte creatieve mogelijkheden met AI.',
        
        // Platform section
        platformTitle: 'Eén platform, eindeloze mogelijkheden',
        platformDescription: 'Zeg vaarwel tegen constant wisselen van tools. WeryAI biedt naadloos geïntegreerde AI‑beeld- en videogenerators, geavanceerde modellen en tools, zodat je eenvoudig indrukwekkende visuele effecten kunt maken en ultieme creativiteit kunt ontketenen.',
        
        // Why choose us
        whyChooseTitle: 'Waarom kiezen voor WeryAI?',
        
        // Feature cards
        professionalTeamTitle: 'Professioneel team',
        professionalTeamDesc: 'Opgericht door een divers team met ervaring in AI‑technologie en multimediaproductie. WeryAI zet zich in om toonaangevende professionele ervaringen te bieden voor jouw creatieve reis.',
        
        innovativeTechTitle: 'Innovatieve technologie',
        innovativeTechDesc: 'Integreert de nieuwste AI‑doorbraken en ondersteunt naadloze toegang tot meerdere modellen zoals Veo 3.1, Sora 2, Nano Banana, FLUX en meer, zodat je eenvoudig hoogwaardige video’s, afbeeldingen en andere content kunt genereren.',
        
        userCentricTitle: 'Gebruiker‑gericht',
        userCentricDesc: 'Het platform stelt de gebruikerservaring centraal met een intuïtieve, gebruiksvriendelijke interface en een oneindig canvas, zodat je onbeperkte creatieve ruimte kunt verkennen. Ondertussen staat ons supportteam altijd klaar om je te helpen.',
        
        // CTA section
        ctaTitle: 'Sluit je aan bij 10+ miljoen gebruikers die creëren en geïnspireerd raken met WeryAI',
        ctaButton: 'Begin nu met creëren',
        subjectName: 'Bedrijfsnaam',
        registeredAddress: 'Geregistreerd adres',
        mail: 'E-mail',
        corporate: 'Bedrijfsinformatie',
    },
    id: {
        // Page title
        pageTitle: 'Tentang WeryAI',
        
        // Hero section
        subtitle: 'Pelopor AI untuk video, gambar, dan manusia digital',
        description: 'WeryAI adalah platform kreasi konten multimodal generasi terbaru. Baik gambar dan video yang memukau, manusia digital dinamis dengan kepribadian, maupun kanvas tanpa batas untuk mewujudkan ide liar, WeryAI membuka kemungkinan kreatif tak terbatas berkat AI.',
        
        // Platform section
        platformTitle: 'Satu platform, kemungkinan tanpa batas',
        platformDescription: 'Ucapkan selamat tinggal pada seringnya ganti alat. WeryAI menyediakan generator gambar dan video AI yang terintegrasi mulus, model dan tools canggih, memungkinkan Anda membuat efek visual menakjubkan dengan mudah dan melepas kreativitas sepenuhnya.',
        
        // Why choose us
        whyChooseTitle: 'Mengapa memilih WeryAI?',
        
        // Feature cards
        professionalTeamTitle: 'Tim profesional',
        professionalTeamDesc: 'Didirikan oleh tim beragam dengan pengalaman teknologi AI dan produksi multimedia, WeryAI berkomitmen memberikan pengalaman profesional terdepan untuk perjalanan kreatif Anda.',
        
        innovativeTechTitle: 'Teknologi inovatif',
        innovativeTechDesc: 'Mengintegrasikan terobosan AI terbaru, mendukung akses mulus ke banyak model termasuk Veo 3.1, Sora 2, Nano Banana, FLUX, dan lainnya, sehingga Anda dapat menghasilkan video, gambar, dan konten berkualitas tinggi dengan mudah.',
        
        userCentricTitle: 'Berpusat pada pengguna',
        userCentricDesc: 'Platform ini mengutamakan pengalaman pengguna dengan antarmuka intuitif dan mudah digunakan serta kanvas tanpa batas, membantu Anda menjelajahi ruang kreatif tak terbatas. Sementara itu, tim dukungan kami selalu siap membantu.',
        
        // CTA section
        ctaTitle: 'Bergabunglah dengan 10+ juta pengguna yang berkarya dan terinspirasi bersama WeryAI',
        ctaButton: 'Mulai berkarya sekarang',
        subjectName: 'Nama perusahaan',
        registeredAddress: 'Alamat terdaftar',
        mail: 'Email',
        corporate: 'Informasi perusahaan',
    },
    tr: {
        // Page title
        pageTitle: 'WeryAI Hakkında',
        
        // Hero section
        subtitle: 'AI video, görsel ve dijital insan üretiminde öncü',
        description: 'WeryAI, yeni nesil çok modlu içerik üretim platformudur. İster etkileyici görseller ve videolar, ister kişiliğe sahip dinamik dijital insanlar, ister vahşi fikirleri hayata geçirmek için sonsuz tualler olsun; WeryAI, AI ile sınırsız yaratıcı olasılıkların kapısını açar.',
        
        // Platform section
        platformTitle: 'Tek platform, sonsuz olasılık',
        platformDescription: 'Sık sık araç değiştirmeye veda edin. WeryAI, kusursuz entegre AI görsel ve video üreticileri ile gelişmiş modeller ve araçlar sunar; böylece çarpıcı görsel efektleri kolayca oluşturabilir ve yaratıcılığınızı en üst düzeye çıkarabilirsiniz.',
        
        // Why choose us
        whyChooseTitle: 'Neden WeryAI?',
        
        // Feature cards
        professionalTeamTitle: 'Profesyonel ekip',
        professionalTeamDesc: 'AI teknolojisi ve multimedya üretimi deneyimine sahip, farklı uzmanlıklardan oluşan bir ekip tarafından kurulan WeryAI, yaratıcı yolculuğunuz için sektör lideri profesyonel deneyimler sunmayı taahhüt eder.',
        
        innovativeTechTitle: 'Yenilikçi teknoloji',
        innovativeTechDesc: 'En yeni AI atılımlarını entegre eder; Veo 3.1, Sora 2, Nano Banana, FLUX ve daha fazlası gibi birçok modele sorunsuz erişimi destekler. Böylece yüksek kaliteli video, görsel ve diğer içerikleri kolayca üretebilirsiniz.',
        
        userCentricTitle: 'Kullanıcı odaklı',
        userCentricDesc: 'Platform, sonsuz tuval ile sezgisel ve kullanımı kolay bir arayüz sunarak kullanıcı deneyimini merkeze alır ve sınırsız yaratıcı alanı keşfetmenize yardımcı olur. Ayrıca, özel destek ekibimiz her zaman yanınızdadır.',
        
        // CTA section
        ctaTitle: 'WeryAI ile üreten ve ilham alan 10+ milyon kullanıcıya katılın',
        ctaButton: 'Hemen oluşturmaya başlayın',
        subjectName: 'Şirket adı',
        registeredAddress: 'Kayıtlı adres',
        mail: 'E-posta',
        corporate: 'Kurumsal Bilgiler',
    },
}
